const common =
{
  scrollbarWidth: '48px',
  thumbWidth: '12px',
  thumbRounding: '6px',
  thumbMinHeight: '64px'
}

export const web =
{
  ...common,
  scrollbarWidth: '36px',
  thumbWidth: '8px',
  thumbRounding: '4px',
  thumbMinHeight: '36px'
}

export const tablet =
{
  ...common
}
